type BrowserStorage = Pick<Storage, "getItem" | "setItem" | "removeItem">;

export function getBrowserStorage(): BrowserStorage | null {
  const storage = globalThis.localStorage;
  if (
    !storage ||
    typeof storage.getItem !== "function" ||
    typeof storage.setItem !== "function" ||
    typeof storage.removeItem !== "function"
  ) {
    return null;
  }

  return storage;
}

export function readBrowserStorage(key: string): string | null {
  return getBrowserStorage()?.getItem(key) ?? null;
}

export function writeBrowserStorage(key: string, value: string): void {
  getBrowserStorage()?.setItem(key, value);
}

export function removeBrowserStorage(key: string): void {
  getBrowserStorage()?.removeItem(key);
}
